import React, { useState } from 'react';
import ButtonAction from '../../../../../components/buttons/ButtonAction';
import {
    ArrowRightIcon,
    CancelIconsOptions,
    CheckIconsOptions,
    CheckmarkTitle,
    CrossIconsOptions,
    DoneChip,
    HourglassTitle,
    IconAcceptanceCard,
    IconCancelCard,
    IconSearchCard,
    InfoChip,
    ProvidersTitle,
    SearchTitle,
    CloseIcon,
    WarningChip,
    IconRejectedByVisitorCard,
    IconGuardTitle,
    IconHandCard,
    CheckboxChip,
    IconPassport,
    IconIdentificationCard,
} from '../../../../../components/buttons/IconButtons';
import CustomGenericTittleIconDataChip from '../../../../../components/CustomGenericTittleIconDataChip';
import DropDownMenuProfile from '../../../../../components/DropDown/DropDownMenuProfile';
import { STATUS_MODEL } from '../../../../../enums/statusEnum';
import DropDownMenuItem from '../../../../../components/DropDown/DropDownMenuItem';
import { CustomCheckbox } from '../../../../../components/CustomCheckbox';
import { Trans, useTranslation } from 'react-i18next';
import { ButtonLargeTransparent} from '../../../../../components/buttons/ButtonLargeTransparent';
import {useNavigate } from 'react-router-dom';
import routes from '../../../../../Routes/routes';
import {useDispatch} from 'react-redux';
import {
    publicUpdateVisitorStatusByInvitationId,
} from '../../../../../reduxToolkit/Invitation/InvitationApi';
import {POSITION_MODEL} from '../../../../../Helpers/PositionModel';
import {invitationInTime} from "../../Invitation/Model/Model";
import {t} from "i18next";
import {FILE_TYPE_MODEL} from "../../Visitor/Model/Model";

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

export const allowedDocumentListToLabel = (list, guardFlowId) => {
    if(!list) return [];
    return list?.map((item) => {
        return {
            id: item.id,
            label: item?.label,
            type: item?.type,
            Icon: item?.type === FILE_TYPE_MODEL.INE.id ? IconIdentificationCard : IconPassport,
            subSection: () => {
                return (
                    <>
                        <p className="fs-11px ibl-font-w-400 font-color-general-950">
                            {
                                item.type === FILE_TYPE_MODEL.INE.id ?
                                    guardFlowId ? t("take_photos_of_both_sides_of_the_id_card") : t("take_photos_of_both_sides_of_your_id_card")
                                    :
                                    t("take_a_photo_of_the_passport_photo_page")
                            }
                        </p>
                    </>
                );
            },
        };
    });
};

const CancelStatusBody = ({title="canceled_attendance_message"}) => {
    const { t } = useTranslation();
    return (
        <div>
            <div className='mt-3'>
                <p className={'font-color-general-950 ibl-ientry-p ibl-font-w-400'}>
                    {t(title)}
                </p>
            </div>
            <div className='d-flex justify-content-center align-items-center mt-4'>
                <IconCancelCard />
            </div>
        </div>
    );
};
const CancelStatusHeader = () => {
    const { t } = useTranslation();
    return (
        <div className='d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center'>
            <CustomGenericTittleIconDataChip
                Icon={CancelIconsOptions}
                iconColor='icon-color-text-950'
                title={'visit_canceled'}
                border={false}
            />
            <div className='mt-2 mt-md-0 col-12 col-md-6 p-0'>
                <ButtonAction
                    name={t('canceled')}
                    className='btn-error-800 ibl-ientry-p ibl-font-w-700 col-12 col-md-6 col-lg'
                    splitName={false}
                />
            </div>
        </div>
    );
};
const RejectedStatusBody = () => {
    const { t } = useTranslation();
    return (
        <div>
            <div className='mt-3'>
                <p className={'font-color-general-950 ibl-ientry-p ibl-font-w-400'}>
                    {t('invitation_declined_message')}
                </p>
            </div>
            <div className='d-flex justify-content-center align-items-center mt-4 mb-3'>
                <IconCancelCard />
            </div>
        </div>
    );
};
const RejectedStatusHeader = () => {
    const { t } = useTranslation();
    return (
        <div className='d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center'>
            <CustomGenericTittleIconDataChip
                Icon={CrossIconsOptions}
                iconColor='icon-color-text-950'
                title={'not_attending'}
                border={false}
            />
            <div className='mt-2 mt-md-0 col-12 col-md-6 p-0'>
                <ButtonAction
                    name={('rejected')}
                    className='btn-error-800 ibl-ientry-p ibl-font-w-700 col-12 col-md-6 col-lg'
                    splitName={false}
                />
            </div>
        </div>
    );
};
const DefaultStatusHeader = () => {
    return (
        <div>
            <CustomGenericTittleIconDataChip Icon={ProvidersTitle} title={'attendance'} border={false} />
        </div>
    );
};
const DefaultStatusBody = ({setVisitorStatus, id, guardFlowId}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [openMenu, setOpenMenu] = useState(null);
    const handleMenuToggle = (menuId) => {
        setOpenMenu((prev) => (prev === menuId ? null : menuId));
    };
    return (
        <>
            <div className='my-3'>
                <h4 className={`ibl-h4 font-color-general-950 ibl-font-w-600`}>{t('greeting')}</h4>
                <p className={'font-color-general-950 ibl-ientry-p ibl-font-w-400'}>{t('invitation_message')}</p>
            </div>
            <div className='d-flex justify-content-center align-items-center mt-5'>
                <div className='col-12 col-md-6 col-lg-4 px-0'>
                    { !guardFlowId &&
                        <DropDownMenuProfile
                            openMenu={openMenu}
                            handleMenuToggle={handleMenuToggle}
                            menuId='profile-menu'
                            name='RSVP'
                            className={'btn-icon-secondary-600-800 rsvp-dropdown col-12 col-md-6 col-lg-4'}
                        >
                            <DropDownMenuItem
                                id={'btn_ac_accept_reject_card_'}
                                name={t('accept')}
                                icon={<CheckIconsOptions fontSize='small'/>}
                                click={() => {
                                    dispatch(publicUpdateVisitorStatusByInvitationId({
                                        invitationId: id,
                                        statusId: STATUS_MODEL.ACCEPTED
                                    })).then(({payload: {data }}) => {
                                        setVisitorStatus(STATUS_MODEL_CARD.ACCEPTED);
                                    });
                                }}
                            />
                            <DropDownMenuItem
                                id={'btn_ac_accept_reject_card_'}
                                name={t('reject')}
                                fontColor={'font-color-error-600'}
                                iconColor={"icon-color-error-code-600"}
                                icon={<IconRejectedByVisitorCard className="icon-color-error-code-600" fontSize='small'/>}
                                click={() => {
                                    dispatch(publicUpdateVisitorStatusByInvitationId({
                                        invitationId: id,
                                        statusId: STATUS_MODEL.REJECTED
                                    })).then(({payload: {data: {data}}}) => {
                                        setVisitorStatus({...STATUS_MODEL_CARD.REJECTED})
                                    });
                                }}
                            />
                        </DropDownMenuProfile>
                    }
                </div>
            </div>
        </>
    );
};
const UnderReviewStatusHeader = ({ guardFlowId }) => {
    const { t } = useTranslation();
    const [openMenu, setOpenMenu] = useState(null);
    const handleMenuToggle = (menuId) => {
        setOpenMenu((prev) => (prev === menuId ? null : menuId));
    };
    return (
        <div className='d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center'>
            <CustomGenericTittleIconDataChip
                Icon={SearchTitle}
                title={'under_review'}
                iconColor='icon-color-text-950'
                border={false}
            />
            <div className='mt-2 mt-md-0 col-12 col-md-6 p-0'>
                {!guardFlowId &&
                    <DropDownMenuProfile
                        openMenu={openMenu}
                        handleMenuToggle={handleMenuToggle}
                        menuId='profile-menu'
                        name='accepted'
                        isAccordion={false}
                        className={'btn-success-600 col-12 col-md-6 col-lg'}
                    >
                        <DropDownMenuItem
                            id={'btn_ac_accept_reject_card_'}
                            name={t('cancel')}
                            fontColor={'font-color-error-600'}
                            iconColor={'font-color-error-600'}
                            icon={<CancelIconsOptions fontSize='small'/>}
                        />
                    </DropDownMenuProfile>
                }
            </div>
        </div>
    );
};
const UnderReviewStatusBody = () => {
    const { t } = useTranslation();
    return (
        <>
            <p className={'font-color-general-950 ibl-ientry-p ibl-font-w-400'}>{t('under_review_message')}</p>
            <div className='d-flex justify-content-center align-items-center mt-2'>
                <IconSearchCard width={65}
                                height={65}
                />
            </div>
        </>
    );
};
const InProgressReviewStatusHeader = ({ setVisitorStatus, id, guardFlowId }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [openMenu, setOpenMenu] = useState(null);
    const handleMenuToggle = (menuId) => {
        setOpenMenu((prev) => (prev === menuId ? null : menuId));
    };
    return (
        <div className='d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center'>
            <CustomGenericTittleIconDataChip
                Icon={SearchTitle}
                title={'you_are_all_set'}
                iconColor='icon-color-text-950'
                border={false}
            />
            <div className='mt-2 mt-md-0 col-12 col-md-6 p-0'>
                {!guardFlowId &&
                    <DropDownMenuProfile
                        openMenu={openMenu}
                        handleMenuToggle={handleMenuToggle}
                        menuId='profile-menu'
                        name='accepted'
                        isAccordion={false}
                        className={'btn-success-600 col-12 col-md-6 col-lg'}
                    >
                        <DropDownMenuItem
                            id={'btn_ac_accept_reject_card_'}
                            name={t('cancel')}
                            fontColor={'font-color-error-600'}
                            iconColor={"icon-color-error-code-600"}
                            icon={<CancelIconsOptions/>}
                            click={() => {
                                dispatch(publicUpdateVisitorStatusByInvitationId({
                                    invitationId: id,
                                    statusId: STATUS_MODEL.CANCELED
                                })).then(({payload: {data }}) => {
                                    setVisitorStatus({...STATUS_MODEL_CARD.CANCELED});
                                });
                            }}
                        />
                    </DropDownMenuProfile>
                }
            </div>
        </div>
    );
};
const InProgressReviewStatusBody = () => {
    const { t } = useTranslation();
    return (
        <div>
            <div className='my-2'>
                <p className={'font-color-general-950 ibl-ientry-p ibl-font-w-400'}>
                    {t('registration_complete_approved')}
                </p>
            </div>
            <div className='d-flex justify-content-center align-items-center'>
                <IconAcceptanceCard/>
            </div>
        </div>
    );
};
const AcceptedStatusHeader = ({ setVisitorStatus, id, guardFlowId }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [openMenu, setOpenMenu] = useState(null);
    const handleMenuToggle = (menuId) => {
        setOpenMenu((prev) => (prev === menuId ? null : menuId));
    };
    return (
        <div className='d-flex justify-content-between align-items-center'>
            <CustomGenericTittleIconDataChip
                Icon={CheckmarkTitle}
                title={'you_are_in'}
                iconColor='icon-color-text-950'
                border={false}
            />
            {!guardFlowId &&
                <DropDownMenuProfile
                    openMenu={openMenu}
                    handleMenuToggle={handleMenuToggle}
                    menuId={`menu_ash_accepted`}
                    name={t('accepted')}
                    isAccordion={false}
                    className={'btn-success-600'}
                >
                    <DropDownMenuItem
                        id={'btn_ac_accept_reject_card_'}
                        name={t('cancel')}
                        fontColor={'font-color-error-600'}
                        iconColor={"icon-color-error-code-600"}
                        icon={<CancelIconsOptions/>}
                        click={() => {
                            dispatch(publicUpdateVisitorStatusByInvitationId({
                                invitationId: id,
                                statusId: STATUS_MODEL.CANCELED
                            })).then(({payload: {data }}) => {
                                setVisitorStatus({...STATUS_MODEL_CARD.CANCELED});
                            });
                        }}
                    />
                </DropDownMenuProfile>
            }
        </div>
    );
};
const AcceptedStatusBody = ({id, guardFlowId, privacyConsentDate, handleUpdatePrivacyConsent}) => {
    const { t } = useTranslation();

    return (
        <>
            <div className='my-2'>
                <p className={'font-color-general-950 ibl-ientry-p ibl-font-w-400'}>
                    {t('thank_you_for_your_response')}
                </p>
            </div>

            <div className='d-flex align-items-center mb-2'>
                { getPrivacyConsent('cb_asb_checked', privacyConsentDate, handleUpdatePrivacyConsent, privacyConsentDate) }
            </div>

            <ButtonLargeTransparent
                text={t('start_the_registration_process')}
                className='btn-shades-700'
                icon={<ArrowRightIcon width={24} height={24}/>}
                iconColor='font-color-shades-700'
                disabled={!privacyConsentDate}
                url={getUrlParameters({
                    url:routes.invitationDetails.registrationProcess,
                    id,
                    guardFlowId
                })}
            />
        </>
    );
};

export const getPrivacyConsent = (id, privacyConsentValue, handleUpdatePrivacyConsent, disabled) => {
    return <div className={"d-flex align-items-center"}>
                <CustomCheckbox
                    id={id}
                    size='small'
                    className={'checkbox-head'}
                    checked={privacyConsentValue}
                    onChange={handleUpdatePrivacyConsent}
                    disabled={disabled}
                    name={"privacyConsent"}
                />
                <p className='font-color-general-950 fs-span ibl-font-w-300'>
                    <Trans
                        i18nKey='consent_text'
                        components={{
                            1: getLink(routes.docs.dataProcessing, 'data-processing.pdf'),
                            3: getLink(routes.docs.privacyPolicy, 'privacy-policy.pdf')
                        }}
                    />
                </p>
            </div>
}

const BeforeStartingHeader = () => {
    return (
        <div>
            <CustomGenericTittleIconDataChip Icon={IconGuardTitle} title={'before_starting_the_registration_process'} border={false} />
        </div>
    );
};

const BeforeStartingBody = ({ setVisitorStatus }) => {
    const { t } = useTranslation();

    return (
        <>
            <div className='my-3 d-flex'>
                <div className={"mr-2"}><CheckmarkTitle width={16}/></div>
                <p className={'font-color-general-950 ibl-ientry-p ibl-font-w-400'}>
                    { t("verify_that_the_visitor_identity_matches") }
                </p>
            </div>
            <div className='my-3 d-flex'>
                <div className={"mr-2"}><IconHandCard width={16}/></div>
                <p className={'font-color-general-950 ibl-ientry-p ibl-font-w-400'}>
                    { t("hand_the_device_to_the_visitor_description") }
                </p>
            </div>
            <div>
                <ButtonAction
                    id='btn_m_hand_device'
                    name='confirm_hand_device_to_visitor'
                    className={"btn-outlined-secondary-600-00 w-100"}
                    disabled={false}
                    splitName={false}
                    onClick={() =>   setVisitorStatus({...STATUS_MODEL_CARD.VISITOR_CONFIRMATION_REQUIRED}) }
                />
            </div>
        </>
    );
};


const VisitorConfirmationRequiredHeader = () => {
    return (
        <div>
            <CustomGenericTittleIconDataChip Icon={CheckboxChip} title={'visitor_confirmation_required'} border={false} />
        </div>
    );
};

const VisitorConfirmationRequiredBody = ({ id, setVisitorStatus, privacyConsentDate,  handleUpdatePrivacyConsent}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    return (
        <>
            <div className='my-3'>
                <p className={'font-color-general-950 ibl-ientry-p ibl-font-w-400'}>
                    { t( privacyConsentDate? "please_review_information_above_carefully": "please_review_information_above_carefully_check_the_box") }
                </p>
            </div>

            <div className='d-flex align-items-center mb-2'>
                { getPrivacyConsent('cb_asb_checked', privacyConsentDate, handleUpdatePrivacyConsent, privacyConsentDate) }
            </div>
            <div>
                <ButtonAction
                    id='btn_m_return_device'
                    name='continue_and_return_device'
                    className={"btn-outlined-secondary-600-00 w-100"}
                    disabled={false}
                    splitName={false}
                    onClick={() => {
                        dispatch(publicUpdateVisitorStatusByInvitationId({invitationId: id, statusId: STATUS_MODEL.ACCEPTED}))
                            .then(({payload: {data: { data }}}) => {
                                 setVisitorStatus({...STATUS_MODEL_CARD.PROCEED_WITH_REGISTRATION})
                        });
                    }}
                />
            </div>
        </>
    );
};


const ProceedWithRegistrationHeader = () => {
    return (
        <div>
            <CustomGenericTittleIconDataChip Icon={CheckboxChip} title={'proceed_with_registration'} border={false} />
        </div>
    );
};

const ProceedWithRegistrationBody = ({ id, guardFlowId, privacyConsentDate,  handleUpdatePrivacyConsent, getUserRestriction, statusId, identityValidation}) => {
    const { t } = useTranslation();

    return (
        <>
            <div className='my-3'>
                <p className={'font-color-general-950 ibl-ientry-p ibl-font-w-400'}>
                    { t("the_visitor_was_confirmed_their_information") }
                </p>
            </div>

            <div className='d-flex align-items-center mb-2'>
                { getPrivacyConsent('cb_asb_checked', privacyConsentDate, handleUpdatePrivacyConsent, privacyConsentDate) }
            </div>
            <div>
                <ButtonLargeTransparent
                    text={t(isStart(getUserRestriction, statusId, identityValidation) ? 'start_the_registration_process': 'continue_registration')}
                    className='btn-shades-700'
                    icon={<ArrowRightIcon/>}
                    iconColor='font-color-shades-700'
                    disabled={!privacyConsentDate}
                    url={getUrlParameters({
                        url:routes.invitationDetails.registrationProcess,
                        id,
                        guardFlowId
                    })}
                />
            </div>
        </>
    );
};

/**
 * Checks if the visitor process is in the "start" stage.
 *
 * A visitor is considered at the start if either:
 * - The visitor does not require validation and their status is `PENDING_TO_UPLOAD_INFORMATION`, or
 * - Their identity validation is `PENDING_TO_UPLOAD_INFORMATION` and their status is also `PENDING_TO_UPLOAD_INFORMATION`.
 */
export const isStart = (getUserRestriction, statusId, identityValidation) => {
    return (!getUserRestriction.validationVisitor && statusId === STATUS_MODEL.PENDING_TO_UPLOAD_INFORMATION)
        || (identityValidation === STATUS_MODEL.PENDING_TO_UPLOAD_INFORMATION && statusId === STATUS_MODEL.PENDING_TO_UPLOAD_INFORMATION);

}

/**
 * Checks if the visitor process is "complete".
 *
 * A visitor is considered complete if either:
 * - The visitor does not require validation and their status is `APPROVED`, or
 * - Their identity validation is `VALIDATED` and their status is also `APPROVED`.
 */
export const isComplete = (getUserRestriction, statusId, identityValidation) => {
    return (!getUserRestriction.validationVisitor && statusId === STATUS_MODEL.APPROVED)
        || (identityValidation === STATUS_MODEL.VALIDATED && statusId === STATUS_MODEL.APPROVED);
}

export const getUrlParameters = ({url, id, guardFlowId}) => {
    if(guardFlowId)
        return `${url}${id}/${guardFlowId}`;

    return `${url}${id ? id : ''}`;
}

export const downloadPrivacyDocs = (url, name) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

const getLink = (url, name) => {
  return  <span
      className='fs-span  ibl-font-w-300 text-decoration-underline  font-color-secondary-500 cursor-pointer'
      onClick={()=>{
          downloadPrivacyDocs(url, name)
      }}
  />
}

const RegistrationInProgressStatusHeader = ({ setVisitorStatus, id, guardFlowId, setIcsDownload, hostName }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [openMenu, setOpenMenu] = useState(null);
    const handleMenuToggle = (menuId) => {
        setOpenMenu((prev) => (prev === menuId ? null : menuId));
    };
    return (
        <div className='d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center'>
            <CustomGenericTittleIconDataChip
                Icon={HourglassTitle}
                title={'registration_in_progress'}
                iconColor='icon-color-text-950'
                border={false}
            />
            <div className='mt-2 mt-md-0 col-12 col-md-6 p-0'>
                {!guardFlowId &&
                    <DropDownMenuProfile
                        openMenu={openMenu}
                        handleMenuToggle={handleMenuToggle}
                        menuId='profile-menu'
                        name={t('accepted')}
                        isAccordion={false}
                        className={'btn-outlined-success-600 col-12 col-md-6 p-0'}
                    >
                        <DropDownMenuItem
                            id={'btn_ac_accept_reject_card_'}
                            name={t('cancel')}
                            fontColor={'font-color-error-600'}
                            iconColor={"icon-color-error-code-600"}
                            icon={<CancelIconsOptions/>}
                            click={() => {
                                dispatch(publicUpdateVisitorStatusByInvitationId({
                                    invitationId: id,
                                    statusId: STATUS_MODEL.CANCELED
                                })).then(({payload: {data }}) => {
                                    setVisitorStatus({...STATUS_MODEL_CARD.CANCELED});
                                });

                            }}
                        />
                    </DropDownMenuProfile>
                }
            </div>
        </div>
    );
};
const RegistrationInProgressStatusBody = ({id, guardFlowId, privacyConsentDate, handleUpdatePrivacyConsent}) => {
    const { t } = useTranslation();

    return (
        <>
            <div className='my-2'>
                <p className={'font-color-general-950 ibl-ientry-p ibl-font-w-400'}>{t('you_are_almost_there')}</p>
            </div>
            <div className='d-flex align-items-center mb-2'>
                { getPrivacyConsent('cb_asb_checked', privacyConsentDate, handleUpdatePrivacyConsent, privacyConsentDate)}
            </div>
            <ButtonLargeTransparent
                text={t('continue_registration')}
                className='btn-shades-300-50'
                icon={<ArrowRightIcon/>}
                disabled={!privacyConsentDate}
                url={getUrlParameters({
                    url: routes.invitationDetails.registrationProcess,
                    id,
                    guardFlowId
                })
                }
            />
        </>
    );
};

export const CustomTransLink = ({ translationKey, path, colorClass = 'font-color-secondary-500' }) => {
    const navigate = useNavigate();

    return (
        <Trans
            i18nKey={translationKey}
            components={{
                1: (
                    <span
                        className={`fs-span ibl-font-w-300 text-decoration-underline cursor-pointer ${colorClass}`}
                        onClick={() => navigate(path)}
                    />
                ),
            }}
        />
    );
};

export const STATUS_MODEL_CARD = {
    BEFORE_STARTING: {//Guard flow
        ID: null,
        NAME: '',
        DIVIDER: true,
        HEADER: (props) => <BeforeStartingHeader {...props} />,
        BODY: (props) => <BeforeStartingBody {...props} />,
    },
    VISITOR_CONFIRMATION_REQUIRED: {//Guard flow
        ID: null,
        NAME: '',
        DIVIDER: true,
        HEADER: (props) => <VisitorConfirmationRequiredHeader {...props} />,
        BODY: (props) => <VisitorConfirmationRequiredBody {...props} />,
    },
    PROCEED_WITH_REGISTRATION: {//Guard flow
        ID: null,
        NAME: '',
        DIVIDER: true,
        HEADER: (props) => <ProceedWithRegistrationHeader {...props} />,
        BODY: (props) => <ProceedWithRegistrationBody {...props} />,
    },
    UNATTENDED: {
        ID: STATUS_MODEL.UNATTENDED,
        NAME: 'UNATTENDED',
        DIVIDER: true,
        HEADER: (props) => <DefaultStatusHeader {...props} />,
        BODY: (props) => <DefaultStatusBody {...props} />,
    },
    CANCELED: {
        ID: STATUS_MODEL.CANCELED,
        NAME: 'CANCELED',
        DIVIDER: false,
        HEADER: (props) => <CancelStatusHeader {...props} />,
        BODY: (props) => <CancelStatusBody {...props} />,
    },
    CANCELED_BY_EMPLOYEE: {
        ID: STATUS_MODEL.CANCELED,
        NAME: 'CANCELED',
        DIVIDER: false,
        HEADER: (props) => <CancelStatusHeader {...props} />,
        BODY: (props) => <CancelStatusBody {...props} title={"canceled_by_admin"} />,
    },
    REJECTED: {
        ID: STATUS_MODEL.REJECTED,//95
        NAME: 'REJECTED',
        DIVIDER: false,
        HEADER: (props) => <RejectedStatusHeader {...props} />,
        BODY: (props) => <RejectedStatusBody {...props} />,
    },
    PENDING_REVIEW: {
        ID: STATUS_MODEL.PENDING_REVIEW,//133
        NAME: 'PENDING_REVIEW',
        DIVIDER: false,
        HEADER: (props) => <UnderReviewStatusHeader {...props} />,
        BODY: (props) => <UnderReviewStatusBody {...props} />,
    },
    VALIDATED: {
        ID: STATUS_MODEL.IN_PROGRESS,//135
        NAME: 'IN_PROGRESS',
        DIVIDER: false,
        HEADER: (props) => <InProgressReviewStatusHeader {...props} />,
        BODY: (props) => <InProgressReviewStatusBody {...props} />,
    },
    REGISTRATION_IN_PROGRESS: {
        ID: STATUS_MODEL.IN_PROGRESS,//135
        NAME: 'REGISTRATION_IN_PROGRESS',
        DIVIDER: false,
        HEADER: (props) => <RegistrationInProgressStatusHeader {...props} />,
        BODY: (props) => <RegistrationInProgressStatusBody {...props} />,
    },
    ACCEPTED: {
        ID: STATUS_MODEL.ACCEPTED,
        NAME: 'ACCEPTED',
        DIVIDER: false,
        HEADER: (props) => <AcceptedStatusHeader {...props} />,
        BODY: (props) => <AcceptedStatusBody {...props} />,
    },
};

export const getStatusChip = (id, guardFlowId) => ({
    REMINDER: {
        ID: 1,
        NAME: (
            <CustomTransLink
                colorClass='font-color-secondary-700'
                translationKey='reminder_incomplete_registration'
                path={getUrlParameters({
                    url: routes.invitationDetails.registrationProcess,
                    id,
                    guardFlowId
                })}
            />
        ),
        ICON: InfoChip,
        CLASSNAME: 'chip-secondary-150-100 w-100 m-0 p-0 justify-content-start',
        POSITION: POSITION_MODEL.LEFT,
        DELETE_ICON: <CloseIcon fontSize='small' height={16} width={16} className="icon-color-secondary-700" />
    },
    ALL_SET: {
        ID: 2,
        NAME: 'all_set_registration_approved',
        ICON: DoneChip,
        CLASSNAME: 'chip-success-150-100 w-100 m-0 p-0 justify-content-start',
        POSITION: POSITION_MODEL.LEFT,
        DELETE_ICON: <CloseIcon fontSize='small' height={16} width={16} className="icon-color-success-700" />
    },
    UPDATE: {
        ID: 3,
        NAME: (
            <CustomTransLink
                colorClass='font-color-warning-700'
                translationKey='update_required_host_changes'
                path={getUrlParameters({
                    url: routes.invitationDetails.registrationProcess,
                    id,
                    guardFlowId
                })}
            />
        ),
        ICON: WarningChip,
        CLASSNAME: 'chip-warning-150-100 w-100 m-0 p-0 justify-content-start',
        POSITION: POSITION_MODEL.LEFT,
        DELETE_ICON: <CloseIcon fontSize='small' height={16} width={16} className="icon-color-warning-700" />
    },
    COMPLETE: {
        ID: 4,
        NAME: 'reminder_complete',
        ICON: DoneChip,
        CLASSNAME: 'chip-success-150-100 w-100 m-0 p-0 justify-content-start',
        POSITION: POSITION_MODEL.LEFT,
        DELETE_ICON: <CloseIcon fontSize='small' height={16} width={16} className="icon-color-success-700" />
    },
});

export const STEP_MODEL = {
    COMPLETE: {
        TOTAL: 7,
        NAME: 'COMPLETE'
    },
    FILES: {
        TOTAL: 4,
        NAME: 'FILES'
    },
    FACE: {
        TOTAL: 4,
        NAME: 'FACE'
    }
}

export const TAB_INDEX = {
    ONE: 1,
    TWO: 2,
    THREE: 3,
    FOUR: 4,
    FIVE: 5,
    SIX: 6
};

/**
 * Redirects the user to the invitation details page if the invitation has expired.
 *
 * @param {Object} invitation - Invitation object containing at least an `id` and `endDate`.
 * @param {Function} navigate - Navigation function used to redirect the user.
 *
 * The function checks whether the invitation exists and whether its end date is still valid.
 * If the invitation has expired, it redirects the user to the corresponding details view.
 */
export const invitationIsExpired = (invitation, navigate) => {
    if(invitation && !invitationInTime(invitation?.endDate)){//Validate if invitation in time
        navigate(routes.invitationDetails.invitation + invitation.id);
    }
}


/**
 * Redirects the user to the invitation details page if the user has account blocked.
 *
 * @param {Object} invitation - Invitation object containing at least an `id` .
 * @param {Function} navigate - Navigation function used to redirect the user.
 *
 * The function checks whether the invitation exists and whether its end date is still valid.
 * If the invitation has expired, it redirects the user to the corresponding details view.
 */
export const invitationIsBlocked = (invitation, navigate) => {
    if(invitation?.visitorUserStatusId === STATUS_MODEL.ACCOUNT_LOCKED){
        navigate(routes.invitationDetails.invitation + invitation.id);
    }
}

